"use strict";
exports.__esModule = true;
exports.EMBED_RELINK_VERIFY_IDENTITY = void 0;
exports.EMBED_RELINK_VERIFY_IDENTITY = {
    HEADER: 'Verify your identity',
    BODY: 'In order to finish connecting to your property, please verify your identity to secure your account.',
    CTA: 'Continue',
    ERROR_MODAL_TITLE1: 'Something went wrong',
    ERROR_MODAL_TITLE2: 'Information doesn’t match our records',
    ERROR_MODAL_CONTENT1: 'Your date of birth and social security number must match the information you entered when you created your account.',
    ERROR_MODAL_CONTENT2: 'We were unable to verify your identity. Try again or ',
    ERROR_MODAL_CONTENT3: 'reach out to our support team',
    ERROR_MODAL_CONTENT4: 'for assistance',
    VERIFYING1: 'Hang tight',
    VERIFYING2: 'Please keep this page open while we verify your identity',
    VERIFYING3: 'This may take a few minutes'
};
